import React from 'react'
import PropTypes from 'prop-types'
import { isUserStaff, isUserVendor, isUserOrgAdmin, isUserProvider, isUserPatient } from '../../../lib/helpers'
import HomeViewStaff from './HomeViewStaff'
import HomeViewProvider from './HomeViewProvider'
import Spinner from 'react-spinkit'
import _ from 'lodash'

class HomeView extends React.Component {
  static defaultProps = {
    user: null
  }

  static propTypes = {
    user: PropTypes.shape({})
  }

  render () {
    const { user } = this.props
    const isStaff = isUserStaff(user)
    const isVendor = isUserVendor(user)
    const isOrgAdmin = isUserOrgAdmin(user)
    const requirePatient = isUserProvider(user)
    const isPatient = isUserPatient(user)
    if (!user) {}
    if (!user || !user.email) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <Spinner name='double-bounce' color='red' />
        </div>
      )
    } else {

      if(user.is_at_home_user){
        window.location.href = 'https://clinic.athelas.com';
      }

      return (
        <div>
          {
            isStaff || isVendor || isOrgAdmin
            ? <HomeViewStaff {...this.props} />
            : (isPatient
                ? 
                <div> You are not authorized to use this page.</div>
                :
                <HomeViewProvider {...this.props} requirePatient={requirePatient} />
              )
          }
        </div>
      )
    }
  }
}

export default HomeView



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js